import clz from 'classnames';
import Link from 'next/link';
import { FunctionComponent, useContext, useState } from 'react';
import { observer } from 'mobx-react';

import styles from './FoldedList.module.sass';
import { LinkItem, ParentItem } from '../types';
import { HomePageStoreContext } from '../../../model/context/home-page.context';
import DisplayToggleBox from '../DisplayToggleBox';
import SubItemList from './SubItemList';

export interface FoldedListProps {
    list: ParentItem[];
}

const FoldedList: FunctionComponent<FoldedListProps> = observer(({ list }) => {
    // State
    const [foldedStateMap, setFoldedState] = useState<Record<string, boolean>>(
        list.reduce((accu, item) => ({ ...accu, [item.id]: true }), {})
    );
    // Context
    const { popoutStore } = useContext(HomePageStoreContext);

    // Event Handler
    const toggleSubItemList = (id: string, subItems: LinkItem[]) => () => {
        if (!subItems || subItems.length === 0) return;
        setFoldedState({ ...foldedStateMap, [id]: !foldedStateMap[id] });
    };

    const parentItems = list.map(({ id, text, path = '', newWin, subItems }) => (
        <div key={id} className={clz(styles.itemContainer, foldedStateMap[id] && styles.collapsed)}>
            {/* Link or not */}
            {subItems ? (
                <span className={styles.parentItem} onClick={toggleSubItemList(id, subItems)}>
                    {text}
                </span>
            ) : (
                <Link href={path}>
                    <a
                        className={styles.parentItem}
                        target={newWin ? '_blank' : '_self'}
                        onClick={() => popoutStore.toggleNavBurger(false)}
                    >
                        {text}
                    </a>
                </Link>
            )}
            {/* Display an arrow or not */}
            {subItems ? <span className={styles.arrow} /> : null}
            {/* SubItemList */}
            {subItems ? (
                <DisplayToggleBox hidden={foldedStateMap[id]}>
                    <SubItemList
                        items={subItems}
                        onClick={() => popoutStore.toggleNavBurger(false)}
                    />
                </DisplayToggleBox>
            ) : null}
        </div>
    ));
    return <div className={styles.container}>{parentItems}</div>;
});

export default FoldedList;
